import {createDeepSlice} from "./base";

export interface IMap {
    dragging?: number[]
    turn: number
    offset: number[]
    player?: string
    user?: string
}

const initialState: IMap = {
    offset: [0, 0],
    turn: 0
};
const slice = createDeepSlice<IMap>("map", initialState);

export const {remove, update} = slice.actions;
export default slice.reducer;